import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'app/services/user.service';
import { BehaviorSubject } from 'rxjs';

interface INoShowEmmitedValue {
	appointmentId: string;
	noShow: boolean;
	notEditable: boolean;
	reasonId: string;
}

@Injectable({
	providedIn: 'root',
})
export class PromptuarySidebarService {
	public noShowObservable: BehaviorSubject<INoShowEmmitedValue> =
		new BehaviorSubject<INoShowEmmitedValue>(null);
	public registerObservable: BehaviorSubject<{ id: string }> =
		new BehaviorSubject<{ id: string }>(null);
	public isOpenObservable: BehaviorSubject<boolean> =
		new BehaviorSubject<boolean>(false);
	public state;
	public isOpen = false;
	public mainType;

	constructor(public user: UserService, public router: Router) {
		this.user.getAuthState().subscribe((user: firebase.User) => {
			if (user) {
				this.user.getProfileData().then((res) => {
					this.mainType = res.mainType;
				});
			}
		});
	}

	public toggleSidebar(value) {
		this.isOpen = value;
		this.isOpenObservable.next(this.isOpen);
	}

	public setState(state: {
		contactId: string;
		appointmentId: string;
		mainType: string;
		from: string;
	}) {
		this.state = state;
	}

	public openSidebarOrGoToPage(profileId, appointmentId, from) {
		if (this.mainType === 'psychiatrist') {
			this.router.navigateByUrl(`/promptuary/${appointmentId}/${profileId}`, {
				state: {
					from: from,
				},
			});
		} else {
			this.setState({
				contactId: profileId,
				appointmentId: appointmentId,
				from: from,
				mainType: this.mainType,
			});
			this.toggleSidebar(true);
		}
	}
}
